

//import { HashRouter } from 'react-router-dom';
import { hashHistory } from 'react-router';
// might be better to expose config variables to the browser to be consumed instead of reading config files.
import { authApi, publicApi } from '../constants/config';
import { showGlobalSpinner, hideGlobalSpinner, showGlobalMessage} from '../actions/environmentActions';
import { getToken, clearToken } from './tokenUtil'
import axios from 'axios';


let _lastFetch = null;
let _tokenName = null;
let _token = null;

const _fetcher = axios.create({
    timeout: 20000,
    validateStatus: function (status) {
        return status >= 200 && status <= 403; 
    }
});

        
_fetcher.interceptors.request.use(
    function(config) {

        config.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';
        //config.headers.common['apiVersion'] = scriptVersion;
        config.headers.common['cloudImage'] = "true";

        if (_token != null ) {
            config.headers.common['Authorization'] = `Bearer ${_token}`;
        }

        //   config.headers.common['Authorization'] = AUTH_TOKEN;
        //   config.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

        return config;
    }, 
    function(err) {
        return Promise.reject(err);
    }
);

class dasFetcher {
    // constructor(tokenName) {
    //     _tokenName = window._tokenName;
    //     alert(_tokenName);
    // }
    //export function resourceApi(options, dispatch, showSpinner) {
    publicApi(options, dispatch, showSpinner){
        return this.apiCall(publicApi, options, dispatch, showSpinner);
    }


    authApi(options, dispatch) {
        return this.apiCall(authApi, options, dispatch, true);
    }

    apiCall(rootUrl, options, dispatch, showSpinner) {

        options.url = rootUrl + options.url;

        var myHeaders = new Headers();
        
        _token = getToken(); // localStorage.getItem(window._tokenName);
       
        if(options.body)
        {
            myHeaders.append("Content-Type", 'application/json');
    
            var data = JSON.stringify( options.body );
            options.body = data;
        }
    
        if (_token != null) {
            myHeaders.append("Authorization", `Bearer ${_token}`);
    
            options.headers = myHeaders;
        }
    
        if(showSpinner === undefined) {
            showSpinner = true;
        }

        if(dispatch && showSpinner) {
            dispatch(showGlobalSpinner());
        }

        _lastFetch = new Date();

        return _fetcher(options)
        .then(object =>  {

            if(dispatch) {
                dispatch(hideGlobalSpinner());
            }

            if(!object){
                return Promise.reject();
            }

            if(object.status === 400) // 400 will be OUR handled error code
            {
                console.log(object);

                if(object.data.message) {
                    if(dispatch) {
                        dispatch(showGlobalMessage(object.data.message, true));
                    }
                }

                if(object.data.Message) {
                    if(dispatch) {
                        dispatch(showGlobalMessage(object.data.Message, true));
                    }
                }

                return Promise.reject(object);
                //return object;
            }
            // else if(object.status === 301) // 301 Moved permanently - code received when apiVersion mismatch 
            // {
            //     //dispatch(inactivateApp());

            //     Promise.reject(object);
            // }
            else if(object.status === 401) // 401 should always force a login event.
            {
                // window.localStorage.removeItem('id_token');
                hashHistory.push("/");

                return Promise.reject(object); //not sure if a reject is what we want.
                // we need the object so we can use in a proxy class in the applicationa in question
            }
            else if(object.status === 200)
            {
                // let ct = response.headers.get('Content-Type')
                // if (ct && (ct.match(/application\/json/i) || ct.match(/text\//i))) {
                //     // There is a .json() instead of .text() but
                //     // we're going to store it in sessionStorage as
                //     // string anyway.
                //     // If we don't clone the response, it will be
                //     // consumed by the time it's returned. This
                //     // way we're being un-intrusive.
                //     response.clone().text().then(content => {
                //     sessionStorage.setItem(cacheKey, content)
                //     })
                // }
    
                return Promise.resolve(object);
            }
            else {

                return object;
     
            }
        })
        .catch(function(err) {
            console.log("Error: ", err);

            return Promise.reject(err);

            // if(dispatch) {
            //     dispatch(hideGlobalSpinner());
            // }
            
            // if(!err) {
            //     return Promise.reject();
            // }
            
            // if(err.status === 401)
            // {
            //     console.log('Auth Error');
            // }
            // if(err.status === 403)
            // {
            //     console.log('Auth Error2');
            // }

            // if(err.type !== "cors") {
            //     // this is happening a lot. 
            //     //dispatch(showGlobalMessage("An error occurred with the last request. If the problem persists please close and re-open the app.", true));
            // }
            
        });
    }
}

//export { dasFetcher as default}


function apiCall(rootUrl, options, dispatch, showSpinner) {

    options.url = rootUrl + options.url;

    var myHeaders = new Headers();
    
    _token = getToken(); // localStorage.getItem(window._tokenName);
   
    if(options.body)
    {
        myHeaders.append("Content-Type", 'application/json');

        var data = JSON.stringify( options.body );
        options.body = data;
    }

    if (_token != null) {
        myHeaders.append("Authorization", `Bearer ${_token}`);

        options.headers = myHeaders;
    }

    if(showSpinner === undefined) {
        showSpinner = true;
    }

    if(dispatch && showSpinner) {
        dispatch(showGlobalSpinner());
    }

    _lastFetch = new Date();

    return _fetcher(options)
    .then(object =>  {

        if(dispatch) {
            dispatch(hideGlobalSpinner());
        }

        if(!object){
            return Promise.reject();
        }

        if(object.status === 400) // 400 will be OUR handled error code
        {
            console.log(object);

            if(object.data.message) {
                if(dispatch) {
                    dispatch(showGlobalMessage(object.data.message, true));
                }
            }

            if(object.data.Message) {
                if(dispatch) {
                    dispatch(showGlobalMessage(object.data.Message, true));
                }
            }

            return Promise.reject(object);
            //return object;
        }
        // else if(object.status === 301) // 301 Moved permanently - code received when apiVersion mismatch 
        // {
        //     //dispatch(inactivateApp());

        //     Promise.reject(object);
        // }
        else if(object.status === 401) // 401 should always force a login event.
        {
            clearToken();
                          
            //Only showing the session message on IOS devices due to a current bug with android.
            if(dispatch && (window.device && window.device.platform.toLowerCase() === 'ios')) {
                dispatch(showGlobalMessage("Your session has expired."));
            }

            // window.localStorage.removeItem('id_token');
            hashHistory.push("/");

            return Promise.reject(object); //not sure if a reject is what we want.
            // we need the object so we can use in a proxy class in the applicationa in question
        }
        else if(object.status === 200)
        {
            // let ct = response.headers.get('Content-Type')
            // if (ct && (ct.match(/application\/json/i) || ct.match(/text\//i))) {
            //     // There is a .json() instead of .text() but
            //     // we're going to store it in sessionStorage as
            //     // string anyway.
            //     // If we don't clone the response, it will be
            //     // consumed by the time it's returned. This
            //     // way we're being un-intrusive.
            //     response.clone().text().then(content => {
            //     sessionStorage.setItem(cacheKey, content)
            //     })
            // }

            return Promise.resolve(object);
        }
        else {

            return object;
 
        }
    })
    .catch(function(err) {
        console.log("Error: ", err);

        return Promise.reject(err);

        // if(dispatch) {
        //     dispatch(hideGlobalSpinner());
        // }
        
        // if(!err) {
        //     return Promise.reject();
        // }
        
        // if(err.status === 401)
        // {
        //     console.log('Auth Error');
        // }
        // if(err.status === 403)
        // {
        //     console.log('Auth Error2');
        // }

        // if(err.type !== "cors") {
        //     // this is happening a lot. 
        //     //dispatch(showGlobalMessage("An error occurred with the last request. If the problem persists please close and re-open the app.", true));
        // }
        
    });
}

export function resourceApi(options, dispatch, showSpinner) { 
    return apiCall(publicApi, options, dispatch, showSpinner);
}

export function authServer(options, dispatch, showSpinner) { 
    return apiCall(authApi, options, dispatch, true);
}


// WEBPACK FOOTER //
// ./src/utils/fetchUtil.js